import { createAction } from '@reduxjs/toolkit'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import { editModification } from '../../../api/projects-api'
import { IMaterialModificationConflict } from '../../../models/masterSetPlan'
import { updateSavedMaterialModification } from '../../slices/masterSetPlan'
import { selectProjectId } from '../../slices/project'

export const editModificationAction = createAction<IMaterialModificationConflict>('EditModification')

export function* handleEditingMaterialModification(action: ReturnType<typeof editModificationAction>) {
    const projectId: number | null = yield select(selectProjectId)

    if (!projectId) return

    try {
        yield call(
            editModification,
            action.payload.id,
            {
                material_location_id: action.payload.material_location_id,
                coordinates: action.payload.coordinates,
                floor_plan_id: action.payload.floor_plan_id,
                option_ids: action.payload.option_ids,
                cutouts: action.payload.cutouts,
            },
            projectId
        )
        yield put(updateSavedMaterialModification(action.payload))
    } catch (e) {
        yield call(console.error, e)
    }
}

export function* watchForEditingMaterialModification() {
    yield takeEvery(editModificationAction, handleEditingMaterialModification)
}
